import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

const CollapsibleSection = ({ title, children }) => {
  const [open, setOpen] = useState(true);

  return (
    <div className="col-span-2 border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 rounded-2xl shadow-sm p-6 transition-all duration-300">
      <button
        onClick={() => setOpen(!open)}
        className="w-full text-left text-xl font-semibold flex justify-between items-center text-gray-800 dark:text-gray-100"
      >
        <span>{title}</span>
        <span className="transition-transform duration-300">
          {open ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
        </span>
      </button>

      <div
        className={`grid gap-4 mt-4 transition-all duration-300 overflow-hidden ${
          open ? "grid-cols-1 md:grid-cols-2 max-h-[1000px]" : "max-h-0"
        }`}
      >
        {open && children}
      </div>
    </div>
  );
};

export default CollapsibleSection;
